import React, { useMemo } from 'react';
import FilterCollapsibleSection from 'components/sidePanel/searchAndFilter/filter/FilterCollapsibleSection';
import Empty from './Empty';
import { FiltersState } from '../constants';

interface Props {
  filters: FiltersState;
  primaryFilterId: number | undefined;
  setPrimaryFilterId: (id: number) => void;
}
const FiltersContainer = (props: Props) => {
  const { filters, primaryFilterId, setPrimaryFilterId } = props;

  const reorderedFilters = useMemo(() => {
    const primaryFilterIndex = filters.data.findIndex(
      (filter) => filter.id === primaryFilterId,
    );

    if (primaryFilterIndex !== -1) {
      const primaryFilter = filters.data[primaryFilterIndex];
      const updatedFilters = [...filters.data];
      updatedFilters.splice(primaryFilterIndex, 1);
      updatedFilters.unshift(primaryFilter);
      return updatedFilters;
    }

    return filters.data;
  }, [filters, primaryFilterId]);

  return (
    <>
      <div id="filterscontainer" className="flex flex-col h-full">
        {reorderedFilters?.map((filter) => {
          return (
            <FilterCollapsibleSection
              key={filter.id}
              filter={filter}
              primaryFilterId={primaryFilterId}
              setPrimaryFilterId={setPrimaryFilterId}
              disabled={!filters.enableFilters}
            />
          );
        })}
        {filters?.data.length === 0 && <Empty />}
      </div>
    </>
  );
};

export default FiltersContainer;
